/**
 * Een uitdienstlijst lezen (FBK-4): een CSV uit het HR-systeem, of een geplakte lijst.
 *
 * Eén waarde per regel is genoeg. Heeft het bestand een kopregel met "personeelsnummer",
 * "employee_number" of "e-mail", dan telt die kolom; anders de eerste. Scheidingsteken komma,
 * puntkomma of tab, zoals Excel het in Vlaanderen en Nederland wegschrijft.
 */

const HEADER = /^(personeelsnummer|personeels?nr|employee[_ ]?number|nummer|e-?mail|email)$/i;

function cells(line: string): string[] {
  return line.split(/[;,\t]/).map((cell) =>
    cell
      .trim()
      .replace(/^"(.*)"$/, '$1')
      .trim(),
  );
}

export function parseExitList(text: string): string[] {
  // `trim()` haalt ook de BOM weg die Excel vooraan een CSV zet.
  const lines = text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => line !== '');
  if (lines.length === 0) return [];

  const first = cells(lines[0] ?? '');
  const column = first.findIndex((cell) => HEADER.test(cell));
  const rows = column >= 0 ? lines.slice(1) : lines;
  const index = Math.max(column, 0);

  const values = rows.map((line) => cells(line)[index] ?? '').filter((value) => value !== '');
  return [...new Set(values)];
}
